export function moveItem(items, index, direction) {
  const result = [...items];
  const target = index + direction;
  if (target < 0 || target >= result.length) return result;
  [result[index], result[target]] = [result[target], result[index]];
  return result;
}

export function orderConfigurationFields(sections, catalog) {
  const order = new Map(catalog.map((field, index) => [field.id, index]));
  return sections.map((section) => ({ ...section, fieldIds: [...section.fieldIds].sort((a, b) => (order.get(a) ?? catalog.length) - (order.get(b) ?? catalog.length)) }));
}

export function placeField(sections, fieldId, sectionId) {
  return sections.map((section) => ({ ...section, fieldIds: [...section.fieldIds.filter((id) => id !== fieldId), ...(section.id === sectionId ? [fieldId] : [])] }));
}

export function patchField(values, field, value, rowId) {
  if (!field.groupId) return { ...values, scalars: { ...values.scalars, [field.id]: value } };
  return { ...values, groups: { ...values.groups, [field.groupId]: (values.groups[field.groupId] || []).map((row) => row.id === rowId ? { ...row, values: { ...row.values, [field.id]: value } } : row) } };
}

export function accessibleCompanies(companies) {
  return Object.keys(companies || {}).filter((id) => ['active', 'onboarding'].includes(companies[id]?.status));
}

export function onboardingDestination(companies, companyId) {
  return companies?.[companyId]?.status === 'onboarding' ? '/onboarding' : null;
}

export const documentKinds = [
  { id: 'chamber_certificate', label: 'Certificato camerale' },
  { id: 'inail_self_assessment', label: 'Autoliquidazione INAIL' },
  { id: 'dm10', label: 'DM10' },
];

export function operationLabel(operation) {
  if (!operation) return 'In attesa';
  if (operation.error_code === 'ANALYSIS_AWAITING_QUALIFICATION') return 'Analisi da attivare';
  return { pending: 'In attesa', running: 'In corso', succeeded: 'Completata', failed: 'Da riprovare' }[operation.status] || 'In attesa';
}

export function validateIntake(values) {
  const errors = {};
  if (!values.name?.trim() || values.name.length > 255) errors.name = 'Inserisci la ragione sociale';
  if (!/^\d{11}$/.test(values.vatNumber || '')) errors.vatNumber = 'Inserisci una partita IVA di 11 cifre';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.hrEmail?.trim() || '')) errors.hrEmail = 'Inserisci una email valida';
  return errors;
}

export function addProfileRow(values, groupId, id) {
  return { ...values, groups: { ...values.groups, [groupId]: [...(values.groups[groupId] || []), { id, values: {} }] } };
}
